export enum OnSaveType {
  VIEW_SAVED = 'VIEW_SAVED',
  BACK_TO_LIST = 'BACK_TO_LIST',
}
